import React from 'react';
import './App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Experience from './components/Experience';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { LanguageProvider } from './context/LanguageContext';

const Page: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <main className="overflow-hidden">
        <Hero />
        <Stats />
        <Experience />
        <Projects />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Page />
    </LanguageProvider>
  );
}

export default App;
